import React from 'react';
import { useIntl } from 'react-intl';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { useReactlytics } from '@americanexpress/reactlytics';
import { Card, Surface } from '@americanexpress/dls-react';
import clsx from 'clsx';
import { formatDate } from '../../../utils/abandonCartUtils';
import style from '../AbandonHotel.scss';
import AbandonHotelIcon from '../AbandonHotelIcon';
import { useAbandonCartData } from '../../../hooks/useContextApiHook';
import { createAnalytics } from '../../../utils/createAnalyticsUtil';
import ContinueButton from '../ContiueButton/ContinueButton';
import DismissButton from '../DismissButton/DimissButton';

const AbandonHotelDesktop = () => {
  const { formatMessage } = useIntl();
  const isXLDesktop = useMediaBreakpoint('xl-up');
  const { track } = useReactlytics();
  const triggerAnalytics = createAnalytics(track, {
    element: 'hp-desktop-AbandonHotel',
    type: 'click',
  });
  const { data: abandonCartData } = useAbandonCartData();
  const { tripStartDate, tripEndDate, hotelProductSelected } = abandonCartData;

  return (
    <div id="abandonHotelDesktop">
      <OnVisible
        analyticsInfo={{
          element: 'hp-desktop-AbandonHotel',
          detail: null,
        }}
      >
        <Card className={clsx('container pad-2-lr flex flex-align-items-center', style.noVerticalPadding)}>

          <Surface variant="fg-brand-alt" className="pad-1 pad-2-tb row radius-container">
            <div className="flex col-md-9 pad-0-l ">
              <div className="flex-inline pad-1-l flex flex-align-items-center">
                <AbandonHotelIcon />
                <div
                  data-testid="abandon-hotel-desktop-text"
                  style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    width: isXLDesktop ? '80%' : '70%',
                  }}
                >
                  <span style={{ fontWeight: 500 }}>
                    {formatMessage({ id: 'abandonHotel.finish' })}
                  </span>
                  <span>{formatMessage({ id: 'abandonHotel.at' })}</span>
                  <span
                    className="text-capitalize font-weight-medium"
                    style={{ paddingRight: '0.2rem' }}
                  >
                    {hotelProductSelected.toLowerCase()}
                  </span>
                </div>
                <div className="text-nowrap">
                  {formatMessage({ id: 'abandonHotel.for' })}
                  <span className="text-nowrap" style={{ fontWeight: 500 }}>
                    {`${formatDate(tripStartDate)} - ${formatDate(tripEndDate)}`}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-3 pad-0">
              <div className="flex flex-justify-end">
                <ContinueButton
                  triggerAnalytics={triggerAnalytics}
                  buttonTextLocaleId="abandonHotel.continue"
                />
                <DismissButton triggerAnalytics={triggerAnalytics} />
              </div>
            </div>
          </Surface>
        </Card>
      </OnVisible>
    </div>
  );
};

export default AbandonHotelDesktop;
